import { Link } from "react-router-dom";
import type { Category } from "@/types/directory";
import { getCategoryFallbackImage } from "@/utils/fallbackImage";
import SafeImage from "./SafeImage";

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  const fallbackImage = getCategoryFallbackImage(category);
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative h-40 w-full overflow-hidden">
        <SafeImage
          src={category.image}
          fallback={fallbackImage}
          alt={`${category.name} services across coastal Karnataka`}
          title={`${category.name} - Coastal Bizz Connect`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
        <span className="absolute bottom-3 left-3 flex h-10 w-10 items-center justify-center rounded-md bg-background-50/95 text-primary-700">
          <i className={`${category.icon} text-lg`} />
        </span>
        <span className="absolute bottom-3 right-3 inline-flex items-center whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
          {category.businessCount.toLocaleString("en-IN")}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {category.name}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {category.description}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-secondary-700">
          Browse listings
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-arrow-right-line text-[13px] transition-transform duration-200 group-hover:translate-x-0.5" />
          </span>
        </span>
      </div>
    </Link>
  );
}